import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {ProviderModel} from '../provider.model';
import {Injectable} from '@angular/core';
import {ProviderSummaryConverter} from './providerSummary.converter';
import {
    ProviderServiceSummaryConverter
} from '../../../../service/api/entity/converter/providerServiceSummary.converter';

@Injectable()
export class ProviderConverter extends HttpModelConverter<ProviderModel> {

    constructor(private providerSummaryConverter: ProviderSummaryConverter,
                private providerServiceSummaryConverter: ProviderServiceSummaryConverter) {
        super();
    }

    protected createInstance(): ProviderModel {
        return new ProviderModel();
    }

    protected enrichObject(result: ProviderModel, src: ProviderModel) {
        result.summary = this.providerSummaryConverter.convert(src.summary);
        result.services = this.providerServiceSummaryConverter.convertFromArray(src.services);
    }
}
